export const locales = [
  'en',
  'ru',
  'uk',
  'kz',
  'de',
  'ro',
  'uz',
  'pt',
  'es',
] as const;
export const defaultLocale = 'en';
export type Locale = (typeof locales)[number];
